import PropTypes from "prop-types";
import React from "react";
import ENV from "app/utils/ENV";
import { View } from "react-native";
import valueHelpers from "app/utils/valueHelpers";
import colorHelpers from "app/utils/colorHelpers";
import navigationHelpers from "app/utils/navigationHelpers";
import valueActions from "app/utils/valueActions";
import chapterActions from "app/utils/chapterActions";
import richTextHelpers from "app/utils/richTextHelpers";
import Text from "app/components/Text";
import TouchableOpacity from "app/components/TouchableOpacity";
import store from "app/redux/store";
import * as RootNavigation from "app/utils/RootNavigation.js";
import Hoverable from "app/components/Hoverable";
import HoverableTooltip from "app/components/HoverableTooltip";

import MomentBullet from "app/components/chapter/MomentBullet";
import { StyleContext } from "app/contexts/Style";

export default class RichText extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      momemBulletValueIds: [],
      isHovered: false,
      foldedSections: {},
    };
  }

  toggleFold = (key) => {
    this.setState((prev) => ({
      foldedSections: { ...prev.foldedSections, [key]: !prev.foldedSections[key] },
    }));
  };

  componentDidMount = async () => {
    // let { value } = this.props;
    // let values = await valueActions.autocompleteValues("");
    // values = values.filter((v) => v.id != value?.id);
    // this.setState({ values });
  };

  render() {
    let {
      color,
      children,
      snapshotText,
      wrapperStyle,
      defaultFocus,
      ...otherProps
    } = this.props;
    return (
      <Hoverable
        onHoverIn={() => this.setState({ isHovered: true })}
        onHoverOut={() => this.setState({ isHovered: false })}
      >
        <View style={wrapperStyle}>
          {this.formatRichText(children, otherProps)}
        </View>
      </Hoverable>
    );
  }

  formatRichText = (text = "", textProps = {}) => {
    // if (!ENV.WEB) return <Text>{text}</Text>;
    let { color, numberOfLines, lineHeightRatio } = this.props;
    let textStyle = {
      ...this.styles({ ...textProps.style, lineHeightRatio }).text,
      ...(textProps.style || {}),
    };
    if (!!lineHeightRatio) textStyle.lineHeightRatio = lineHeightRatio;
    if (!!color) textStyle.color = color;
    if (this.props.bold) textStyle.fontWeight = "bold";

    let res = [];
    let dres = [];
    // return text;

    // Pre-process lines into normal/code segments
    let allLines = text.split(/[\r\n]/);
    let segments = [];
    let normalLines = [];
    let codeLines = [];
    let inCode = false;

    allLines.forEach((line) => {
      if (line.trim() === "```") {
        if (!inCode) {
          if (normalLines.length > 0) {
            segments.push({ type: "normal", lines: [...normalLines] });
            normalLines = [];
          }
          inCode = true;
          codeLines = [];
        } else {
          segments.push({ type: "code", content: codeLines.join("\n") });
          inCode = false;
        }
      } else if (inCode) {
        codeLines.push(line);
      } else {
        normalLines.push(line);
      }
    });
    if (normalLines.length > 0) {
      segments.push({ type: "normal", lines: normalLines });
    }
    if (inCode && codeLines.length > 0) {
      segments.push({ type: "code", content: codeLines.join("\n") });
    }

    segments.forEach((seg, segIdx) => {
      if (seg.type === "code") {
        res.push(
          <View
            key={`codeblock-${segIdx}`}
            style={{
              backgroundColor: colorHelpers.hexToRgbaString(
                this.context.colors.foreground,
                0.1,
              ),
              borderRadius: 4,
              padding: 8,
              marginVertical: 4,
            }}
          >
            <Text
              {...textProps}
              style={{
                fontFamily: "Courier New",
                fontSize: 14,
                lineHeight: 21,
                color: this.context.colors.foreground,
              }}
            >
              {seg.content}
            </Text>
          </View>,
        );
        return;
      }

      let lineIdx = 0;
      while (lineIdx < seg.lines.length) {
        if (!!numberOfLines && res.length >= numberOfLines) break;
        const txt = seg.lines[lineIdx];
        const key = `${segIdx}-${lineIdx}`;

        if (txt.startsWith("> ")) {
          const foldKey = `${segIdx}-${lineIdx}`;
          const title = txt.slice(2);
          const bodyLines = [];
          let j = lineIdx + 1;
          while (j < seg.lines.length) {
            const next = seg.lines[j];
            if (next.startsWith("> ") || /^#{1,3} /.test(next)) break;
            if (next.length > 0 && !next.startsWith(" ") && !next.startsWith("\t")) break;
            bodyLines.push(next);
            j++;
          }
          lineIdx = j;
          const isExpanded = this.props.foldExpanded !== undefined
            ? this.props.foldExpanded
            : !!this.state.foldedSections[foldKey];
          const handleToggleFold = this.props.onToggleFold
            ? () => this.props.onToggleFold()
            : () => this.toggleFold(foldKey);
          res.push(
            <View key={`fold-${foldKey}`}>
              <TouchableOpacity
                onPress={handleToggleFold}
                style={{ flexDirection: "row", alignItems: "center", gap: 4 }}
              >
                <Text style={[textStyle, { opacity: 0.4, fontSize: (textStyle.fontSize || 14) * 0.8 }]}>
                  {isExpanded ? "▾" : "▸"}
                </Text>
                <Text style={[textStyle, { opacity: 0.6 }]}>{title}</Text>
              </TouchableOpacity>
              {isExpanded && (
                <View style={{ paddingLeft: 12, opacity: 0.85 }}>
                  {bodyLines.map((line, bi) => (
                    <View key={bi}>{this.applySuggestionTags(line, textProps, [textStyle])}</View>
                  ))}
                </View>
              )}
            </View>
          );
          continue;
        }

      if (txt.startsWith("# ")) {
        textStyle.fontWeight = "bold";
        res.push(
          <View style={this.styles(textStyle).header} key={key}>
            {this.applySuggestionTags(txt.replace(/# /, ""), textProps, [
              textStyle,
              this.props.plaintext ? {} : this.styles(textStyle).header1,
            ])}
          </View>,
        );
      } else if (txt.startsWith("## ")) {
        textStyle.fontWeight = "bold";
        res.push(
          <View style={this.styles(textStyle).header} key={key}>
            {this.applySuggestionTags(txt.replace(/#{2} /, ""), textProps, [
              textStyle,
              this.props.plaintext ? {} : this.styles(textStyle).header2,
            ])}
          </View>,
        );
      } else if (txt.startsWith("### ")) {
        textStyle.fontWeight = "bold";
        res.push(
          <View style={this.styles(textStyle).header} key={key}>
            {this.applySuggestionTags(txt.replace(/#{3} /, ""), textProps, [
              textStyle,
              this.props.plaintext ? {} : this.styles(textStyle).header3,
            ])}
          </View>,
        );
        // } else if (!!txt.match(richTextHelpers.bulletRegex)) {
      } else {
        // NB: parse THIS line (txt), not the whole text — using the full
        // string made every plain line render the entire body, so
        // multi-line text appeared duplicated once per line
        let { indentation, bullet, body } = richTextHelpers.getLineObject(txt);
        // } else if ((bullet = richTextHelpers.getBullet(txt))) {
        // let bullet = richTextHelpers.getBullet(txt);
        // let indentation = richTextHelpers.getIndentation(txt);
        let bulletStyleName = `bullet${indentation + 1}`;
        // let contentText = txt.split(`${bullet} `)[1];
        res.push(
          <View style={this.styles().listItem} key={key}>
            {!!indentation && (
              <View style={{ flex: -1 }}>
                <Text {...textProps} style={[textStyle]}>
                  {new Array(indentation).fill("\t").join("")}
                </Text>
              </View>
            )}
            {!!bullet && (
              <View style={{ flex: -1 }}>
                <Text
                  {...textProps}
                  style={[
                    textStyle,
                    this.styles(textStyle).bullet,
                    this.styles(textStyle)[bulletStyleName],
                  ]}
                >
                  {bullet}
                </Text>
              </View>
            )}
            {this.applySuggestionTags(body, textProps, [
              textStyle,
              {
                //color: "purple",
                // backgroundColor: "red",
              },
            ])}
          </View>,
        );
      }
      //  else {
      //   res.push(this.applySuggestionTags(txt, textProps, [textStyle]));
      // }
        lineIdx++;
      }
    });

    return res;

    // // titles
    // // ### ...\n
    // text = text.replace(/#{3} .*[\r\n]+/g, (match) => {
    //   res.push(
    //     <View style={this.styles(textStyle).header}>
    //       <Text style={[textStyle, this.styles(textStyle).header1]}>
    //         {match.replace(/#{3} /, "")}
    //       </Text>
    //     </View>
    //   );
    //   return "";
    // });
    // // ## ...\n
    // text = text.replace(/#{2} .*[\r\n]+/g, (match) => {
    //   res.push(
    //     <View style={this.styles(textStyle).header}>
    //       <Text style={[textStyle, this.styles(textStyle).header2]}>
    //         {match.replace(/#{2} /, "")}
    //       </Text>
    //     </View>
    //   );
    //   return "";
    // });
    // // # ...\n
    // text = text.replace(/# .*[\r\n]+/g, (match) => {
    //   res.push(
    //     <View style={this.styles(textStyle).header}>
    //       <Text style={[textStyle, this.styles(textStyle).header3]}>
    //         {match.replace(/# /, "")}
    //       </Text>
    //     </View>
    //   );
    //   return "";
    // });

    // // lists
    // // bullets
    // text = text.replace(/(?<=[\r\n])- .*[\r\n]/g, (match) => {
    //   res.push(
    //     <View style={this.styles().listItem}>
    //       <Text style={[textStyle, this.styles().bullet]}>•</Text>
    //       <Text style={textStyle}>{match.replace(/- /, "")}</Text>
    //     </View>
    //   );
    //   return "";
    // });

    // return text;
    return res;
  };

  applySuggestionTags = (string, props = {}, style = []) => {
    let rawString = string;
    let { values } = this.state;
    let content = [];

    // if (!!rawString?.length) {
    //   content.push(
    //     <Text {...props} style={style}>
    //       {`\n`}
    //     </Text>
    //   );
    // }

    let searchWords = values
      .map((v) => v.text.toLowerCase())
      .filter((x) => !!x?.length);

    searchWords = searchWords.sort((a, b) => {
      let indexA = string.indexOf(a);
      let indexB = string.indexOf(b);
      return indexA < indexB ? 1 : -1;
    });

    searchWords.forEach((word, i) => {
      let value = values.find((v) => v.text.toLowerCase() == word);
      let matchIndex = string?.toLowerCase().indexOf(word);
      if (matchIndex >= 0) {
        content.push(
          <Text {...props} style={style} key={i}>
            {this.applyInlineStyle(string.slice(0, matchIndex), props, style)}
          </Text>,
        );
        let matchingString = string.slice(matchIndex, matchIndex + word.length);
        content.push(
          <Text
            {...props}
            key={i}
            style={[...style, this.styles().link]}
            onPress={() => RootNavigation.push("Project", { id: value.id })}
            onLongPress={() => this.toggleMomentBullet(value)}
            // onMouseDown={(e) => {
            //   e.stopPropagation();
            //   RootNavigation.push("Project", { id: value.id });
            // }}
          >
            {this.applyInlineStyle(matchingString, props, style)}
          </Text>,
        );
        string = string.slice(matchIndex + word.length);
      }
    });

    if (!!string?.length) {
      content.push(
        <View style={[this.styles().listItem, { flex: 1 }]} key={"string"}>
          <Text {...props} style={style}>
            {this.applyInlineStyle(string, props, style)}
          </Text>
        </View>,
      );
    }

    return (
      <View style={{ flex: 1 }}>
        <Text {...props} style={style}>
          {content}
        </Text>
      </View>
    );
  };

  toggleMomentBullet = (value) => {
    if (!value?.id) return;
    let { momemBulletValueIds } = this.state;
    if (momemBulletValueIds.includes(value.id)) {
      momemBulletValueIds.splice(momemBulletValueIds.indexOf(value.id), 1);
    } else {
      momemBulletValueIds.push(value.id);
    }
    this.setState({ momemBulletValueIds });
  };

  applyInlineStyle = (string, props = {}, style = [], rawText = false) => {
    let rawString = string;
    let content = [];

    // if (rawText) {
    //   return <Text bold>{string}</Text>;
    // }

    if (string.split(/`([^`]+)`/).length >= 3) {
      // `code`
      string.split(/`([^`]+)`/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let newStyle = [
            ...style,
            {
              fontFamily: "Courier New",
              fontSize: 14,
              padding: 2,
              borderRadius: 2,
              backgroundColor: colorHelpers.hexToRgbaString(
                this.context.colors.foreground,
                0.1,
              ),
            },
          ];
          content.push(
            <Text {...props} style={newStyle} key={i}>
              {this.applyInlineStyle(txt, props, newStyle, true)}
            </Text>,
          );
        }
      });
    } else if (string.split(/\b_([^_]+)_\b/).length >= 3) {
      // _italic_
      string.split(/\b_([^_]+)_\b/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let newStyle = [...style, { fontStyle: "italic" }];
          content.push(
            <Text {...props} style={newStyle} key={i}>
              {this.applyInlineStyle(txt, props, newStyle, true)}
            </Text>,
          );
        }
      });
    } else if (string.split(/\b__([^_]+)__\b/).length >= 3) {
      // __underline__
      string.split(/\b__([^_]+)__\b/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          content.push(
            <Text {...props} style={style} underline key={i}>
              {this.applyInlineStyle(txt, props, style, true)}
            </Text>,
          );
        }
      });
    } else if (string.split(/\*([^\*]+)\*/).length >= 3) {
      // *bold*
      string.split(/\*([^\*]+)\*/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let newStyle = [...style, { fontWeight: "bold" }];
          if (this.props.plaintext) newStyle = style;
          content.push(
            <Text {...props} style={newStyle} key={i}>
              {this.applyInlineStyle(txt, props, newStyle, true)}
            </Text>,
          );
        }
      });
    } else if (string.split(/\~([^\~]+)\~/).length >= 3) {
      // ~strike~
      string.split(/\~([^\~]+)\~/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let newStyle = style.map((s) => ({
            ...s,
            opacity: !this.state.isHovered ? 0.8 : 1,
            textDecorationLine: `${
              !!s.textDecorationLine ? `${s.textDecorationLine} ` : ""
            }line-through`,
          }));
          content.push(
            <Text {...props} style={newStyle} strike key={i}>
              {this.applyInlineStyle(txt, props, newStyle, true)}
            </Text>,
          );
        }
      });
    } else if (string.split(/\/{([^}]+)}\//).length >= 3) {
      // /{escaped reference}/
      string.split(/\/{([^}]+)}\//).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          // let newStyle = [...style, { backgroundColor: colorHelpers.hexToRgbaString(color, 0.2), }];
          let newStyle = [...style, this.styles().tagSuggestion];
          content.push(
            <Text {...props} style={newStyle} key={i}>
              {`{${this.applyInlineStyle(txt, props, newStyle, true)}}`}
            </Text>,
          );
        }
      });
    } else if (string.split(/{([^}]+)}/).length >= 3) {
      // {references}
      string.split(/{([^}]+)}/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          // let id = parseInt(txt.split("|")[0]);
          let id = txt.split(/[|-]/)[0];
          let value = null;

          if (id == "parent") {
            id = props.value?.parent_ids[0];
          } else if (id == "self") {
            id = props.value?.id;
          }

          id = parseInt(id);

          if (id == props.value?.id) {
            value = props.value;
            // } else if (id == this.props.value?.id) {
            //   value = this.props.value;
          } else {
            let references = props.references || props.value?.references;
            if (!!references?.length) {
              value = references.find((v) => v.id == id);
            }
            if (!value) {
              // references may be stale or partial (moment-text refs are only
              // folded in lazily server-side) — always fall back to the store
              // (NB: this.state.values was always empty; read redux directly)
              value = store.getState().values.find((v) => v.id == id);
            }
          }

          let parentValue = props.value;

          let color = null;
          let strike = false;
          if (!!value) {
            props.value = value;
            if (txt.includes("|")) {
              txt = txt.split("|")[1] || value.title || value.text;
            } else {
              txt = value.title || value.text;
            }
            if (!!value.completed_at) {
              strike = true;
            }
            color = valueHelpers.getColor(
              value,
              this.context.colorScheme,
              this.context.colors.foreground,
            );
            // color = colorHelpers.hexToRgbaString(color, 0.3);
            // color = colorHelpers.modifyHex(color, 0.5);
          } else txt = "–";

          // remove further references (ex. if the referenced value's title contains another ref)
          if (txt.split(/{([^}]+)}/).length >= 3) {
            txt = valueHelpers.filterRichText(txt, props.value, {
              removeLinebreaks: false,
            });
          }

          if (this.state.momemBulletValueIds.includes(value?.id)) {
            content.push(
              <View
                key={i}
                style={{
                  padding: 10,
                  borderRadius: this.context.sizes.borderRadius,
                  backgroundColor: colorHelpers.hexToRgbaString(color, 0.2),
                }}
              >
                <MomentBullet
                  key={i}
                  moment={{ value }}
                  onEscape={() => this.toggleMomentBullet(value)}
                />
              </View>,
            );
          } else {
            let newStyle = style;
            if (this.props.plaintextReferences) {
              content.push(
                <Text {...props} style={newStyle}>
                  {this.applyInlineStyle(txt, props, newStyle, true)}
                </Text>,
              );
            } else {
              newStyle = style.map((s) => ({
                ...s,
                textDecorationLine:
                  `${
                    !!s.textDecorationLine ? `${s.textDecorationLine} ` : ""
                  }underline` + (strike ? ` line-through` : ""),
              }));
              newStyle.push(this.styles().link);
              newStyle.push({ color });
              if (strike) newStyle.push({ opacity: 0.8 });

              content.push(
                <HoverableTooltip
                  key={i}
                  numberOfLines={1}
                  text={
                    !!parentValue
                      ? "Adopt child"
                      : !!this.props.chapter
                        ? `Pin to chapter`
                        : ""
                  }
                  delay
                  bottomAligned
                  onPress={() => {
                    if (!!parentValue)
                      valueActions.addChild(parentValue.id, value.id);
                    else if (!!this.props.chapter)
                      chapterActions.pinValue(this.props.chapter.id, value.id);
                  }}
                >
                  <TouchableOpacity
                    onPress={(e) => {
                      if (ENV.WEB) {
                        e.stopPropagation();
                        e.preventDefault();
                      }
                      if (!!value) {
                        RootNavigation.push("Project", { id: value.id }, e);
                        return false;
                      }
                    }}
                    onMouseDown={(e) => {
                      if (ENV.WEB) {
                        e.stopPropagation();
                        return false;
                      }
                    }}
                    onLongPress={() => this.toggleMomentBullet(value)}
                    accessibilityRole="link"
                    style={[
                      ...newStyle,
                      ENV.WEB
                        ? null
                        : {
                            // borderWidth: 1,
                            // justifyContent: "center",
                            // padding: 0,
                            minHeight: 20,
                            height: 20,
                          },
                    ]}
                  >
                    <Text {...props} style={newStyle} data={{ txt, props }}>
                      {this.applyInlineStyle(txt, props, newStyle, true)}
                    </Text>
                  </TouchableOpacity>
                </HoverableTooltip>,
              );
            }
          }
        }
      });
    } else if (string.split(/<([^>]+)>/).length >= 3) {
      // <http://hyperlinks.com>
      string.split(/<([^>]+)>/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let newStyle = style.map((s) => ({
            ...s,
            textDecorationLine: `${
              !!s.textDecorationLine ? `${s.textDecorationLine} ` : ""
            }underline`,
          }));
          newStyle.push(this.styles().link);
          // newStyle.push({ color });

          let url = txt;
          if (txt.includes("|")) {
            url = txt.split("|")[1];
            txt = txt.split("|")[0];
          }

          // A pressable Text (not TouchableOpacity) so the link flows inline —
          // a View nested in a Text breaks the line it sits on.
          content.push(
            <Text
              {...props}
              key={i}
              accessibilityRole="link"
              style={newStyle}
              onPress={(e) => {
                if (ENV.WEB) {
                  e.stopPropagation();
                  e.preventDefault();
                }
                // Handle cmd/ctrl+click or middle click to open in new tab
                if (ENV.WEB && (e?.metaKey || e?.ctrlKey || e?.button === 1)) {
                  window.open(url, "_blank");
                } else {
                  navigationHelpers.external(url);
                }
              }}
              onMouseDown={(e) => {
                if (ENV.WEB) {
                  e.stopPropagation();
                }
                // Handle middle mouse button
                if (ENV.WEB && e.button === 1) {
                  e.preventDefault();
                  window.open(url, "_blank");
                }
              }}
            >
              {this.applyInlineStyle(txt, props, newStyle, true)}
            </Text>,
          );
        }
      });
    } else if (string.split(/(\[.*?\]\([^\(\)]+?\))/).length >= 3) {
      // [Renamed Hyperlinks](https://hyperlinks.com)
      string.split(/(\[.*?\]\([^\(\)]+?\))/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let url = txt.match(/\((.*)\)/)[1];
          let title = txt.match(/\[(.*)\]/)[1] || url;
          let newStyle = style.map((s) => ({
            ...s,
            textDecorationLine: `${
              !!s.textDecorationLine ? `${s.textDecorationLine} ` : ""
            }underline`,
          }));
          newStyle.push(this.styles().link);
          // newStyle.push({ color });
          content.push(
            <HoverableTooltip
              key={i}
              numberOfLines={1}
              text={url}
              delay
              bottomAligned
              onPress={() => navigationHelpers.external(url)}
            >
              <TouchableOpacity
                accessibilityRole="link"
                onPress={(e) => {
                  if (ENV.WEB) {
                    e.stopPropagation();
                    e.preventDefault();
                  }
                  // Handle cmd/ctrl+click or middle click to open in new tab
                  if (
                    ENV.WEB &&
                    (e?.metaKey || e?.ctrlKey || e?.button === 1)
                  ) {
                    window.open(url, "_blank");
                  } else {
                    navigationHelpers.external(url);
                  }
                }}
                onMouseDown={(e) => {
                  if (ENV.WEB) {
                    e.stopPropagation();
                  }
                  // Handle middle mouse button
                  if (ENV.WEB && e.button === 1) {
                    e.preventDefault();
                    window.open(url, "_blank");
                  }
                }}
                style={[
                  ...newStyle,
                  ENV.WEB
                    ? null
                    : {
                        minHeight: 20,
                        height: 20,
                      },
                ]}
              >
                <Text {...props} style={newStyle}>
                  {title}
                  {/*this.applyInlineStyle(title, props, newStyle, true)*/}
                </Text>
              </TouchableOpacity>
            </HoverableTooltip>,
          );
        }
      });
    } else if (string.split(/\|([^\|]+)\|/).length >= 3) {
      // |tags|
      string.split(/\|([^\|]+)\|/).forEach((txt, i) => {
        if (!(i % 2)) {
          if (txt.length) {
            content.push(
              <Text {...props} style={style} key={i}>
                {this.applyInlineStyle(txt, props, style, true)}
              </Text>,
            );
          }
        } else {
          let newStyle = [...style, this.styles().tagSuggestion];
          content.push(
            <Text {...props} style={newStyle} key={i}>
              {this.applyInlineStyle(txt, props, newStyle, true)}
            </Text>,
          );
        }
      });
    } else if (string == "---") {
      // --- hr lines
      return (
        <View style={[...style, this.styles().hrWrapper]}>
          <View style={this.styles().hr} />
        </View>
      );
      // content.push(
      //   <Text
      //     {...props}
      //     key={"hr"}
      //     style={[...style, this.styles().hr]}
      //     numberOfLines={1}
      //     ellipsizeMode={"clip"}
      //   >
      //     {new Array(999).fill("-").join("-")}
      //   </Text>
      // );
      // content.push(
      //   <Text {...props} style={style} key={"break"}>
      //     {` \n `}
      //   </Text>
      // );
    } else {
      if (rawText) return string;
      content.push(
        <Text {...props} style={style} key={"raw"}>
          {string}
        </Text>,
      );
    }

    return (
      <Text {...props} style={style}>
        {content}
      </Text>
    );
  };

  styles = (style = {}) => {
    // merge — a partial style (e.g. only lineHeightRatio) must not wipe the
    // default fontSize, which made lineHeight compute to NaN
    style = {
      fontSize: this.context.sizes.default,
      lineHeightRatio: 1.6,
      ...(style || {}),
    };
    if (!style.fontSize) style.fontSize = this.context.sizes.default;
    let fontSize = style.fontSize;
    let lh = style.lineHeightRatio || 1.6;
    return {
      text: {
        fontSize: style.fontSize,
        lineHeight: style.fontSize * lh,
        // wordWrap: "none",
        // cursor: "text",
        overflow: "hidden",
        color: this.context.colors.foreground,
      },
      header: {
        marginTop: style.fontSize * 0.4,
        marginBottom: style.fontSize * 0.4,
        //
        marginTop: style.fontSize * 0.3,
        marginBottom: style.fontSize * 0.1,
      },
      header1: {
        fontSize: style.fontSize * 1.3,
        lineHeight: style.fontSize * 1.3 * lh,
      },
      header2: {
        fontSize: style.fontSize * 1.1,
        lineHeight: style.fontSize * 1.1 * lh,
      },
      header3: {
        fontSize: style.fontSize * 1.05,
        lineHeight: style.fontSize * 1.05 * lh,
      },
      listItem: {
        flexDirection: "row",
        // flexWrap: "no-wrap",
      },
      bullet: {
        // marginRight: style.fontSize * 0.66,
        color: this.context.colors.foreground,
        marginRight: style.fontSize * 0.6,
        marginRight: style.fontSize * 0.25,
        lineHeight: style.fontSize * lh,
        fontSize: style.fontSize * 0.6,
        // color: "red",
      },
      bullet1: {
        fontSize: style.fontSize * 0.4,
      },
      // references
      link: {
        // cursor: "pointer",
      },
      // tags
      tagSuggestion: {
        // cursor: "pointer",
        backgroundColor: this.context.colors.fill,
        borderRadius: this.context.sizes.small,
        paddingHorizontal: this.context.sizes.tiny,
      },
      // hr
      hrWrapper: {
        width: "100%",
        flex: 1,
        // height: 100,
        // backgroundColor: "blue",
        maxWidth: this.context.sizes.WIDTH * 0.9,
        // maxWidth: ENV.WEB * 0.9,
        overflow: "hidden",
        alignSelf: "stretch",
      },
      hr: {
        color: "transparent",
        borderBottomWidth: 1,
        borderColor: this.context.colors.foreground,
        opacity: 0.5,
        width: 9999,
        minWidth: 9999,
      },
    };
  };
}
